import React from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import { Alert, AlertTitle, Button } from "@mui/material"
import i18n from "i18n"

const NoActiveSerieAlert = ({ sx }) => {
  const navigate = useNavigate()

  return (
    <Alert
      severity="warning"
      sx={{ mb: 2, ...sx }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => navigate("/generalProfile")}
        >
          {i18n.t("series.goToNumerationSettings")}
        </Button>
      }
    >
      <AlertTitle>{i18n.t("series.noActiveSerieTitle")}</AlertTitle>
      {i18n.t("series.noActiveSerieDescription")}
    </Alert>
  )
}

NoActiveSerieAlert.propTypes = {
  sx: PropTypes.object,
}

NoActiveSerieAlert.defaultProps = {
  sx: undefined,
}

export default NoActiveSerieAlert
